import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import cn from 'classname';
import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';
import { selectors as rootSelectors } from '../root';

import Calendar from '../shared/calendar/main';
import Filters from '../shared/filters/main';
import ConvertionsQuantity from './components/form/conversions-quantity';
import FixedTable from './components/table/main';
import SwitchControlMulti from '../shared/switch-control/multi/main';
import SwitchControlSingleDecorator from '../shared/switch-control/single/main';
import Groups from './components/groups/main';

const Main = renderViewsState(props => (
	<Animate>
		<div className="container__content affiliates-activity">
			<div className="container__content-title">
				<div className="container__content-title-position">
					<h1 className="title">{props.intl('Affiliates activity')}</h1>
				</div>
			</div>
			<div className="container__content-body">
				<div className="affiliates-activity__filter-position clearfix">
					<Filters {...props} {...props.filters} />
				</div>
				<div className="ui-control-bar">
					<div className="ui-control-bar__item modify-item---grouping">
						<div className="ui-control-bar__item-position">
							<Groups
								initialValues={props.groupSelect.values}
								options={props.groupSelect.options}
								onChange={props.setGroups}
							/>
						</div>
					</div>
					<div className="ui-control-bar__item modify-item---calendar">
						<div className="ui-control-bar__item-position">
							<Calendar
								{...props.calendar}
								onInit={props.calendarInit}
								onToggle={props.calendarToggle}
								onChange={props.calendarChange}
								onApply={props.calendarApply}
								intl={props.intl}/>
						</div>
					</div>
					<div className="ui-control-bar__item modify-item---qtn">
						<div className="ui-control-bar__item-position">
							<ConvertionsQuantity
								{...props}
								destroyOnUnmount={false}
								initialValues={props.conversionQuantityInitialValues}/>
						</div>
					</div>
					<div className="ui-control-bar__item modify-item---switch-control-period">
						<div className="ui-control-bar__item-position">
							<SwitchControlSingleDecorator transformToDropdown={true} activateBreakpoint={2000}>
								{ props.datePeriodFilters.map(filter => (
									<button
										key={filter.name}
										value={props.intl(filter.placeholder)}
										onClick={() => props.choosePeriodDateFilter(filter.name)}
										className={cn('ui-btn ui-btn-secondary', filter.active && 'active')}>
										{ props.intl(filter.placeholder) }
									</button>
								)) }
							</SwitchControlSingleDecorator>
						</div>
					</div>
					<div className="ui-control-bar__item modify-item---switch-control">
						<div className="ui-control-bar__item-position">
							<SwitchControlMulti
								intl={props.intl}
								filters={props.cellConfig}
								transformToDropdown={true}
								activateBreakpoint={1710}
								choose={props.toggleCellFilter} />
						</div>
					</div>
					<div className="ui-control-bar__item">
						<div className="ui-control-bar__item-position">
							<button className="ui-btn ui-btn-primary apply" onClick={props.apply}>{props.intl('Apply')}</button>
							<button className="ui-btn ui-btn-secondary ui-icon-clear" onClick={props.clear} />
						</div>
					</div>
				</div>

				<div className="affiliates-activity_table-position">
					<FixedTable {...props} />
				</div>
				<div className="affiliates-activity-total">
					Total: {props.table.rows.filter((item) => item.column.is_total).length}
				</div>
			</div>
		</div>
	</Animate>
), 'view');

export default connect(
	state => ({
		data: selectors.getData(state),
		intl: selectors.getIntl(state),
		signupFilterState: selectors.getAffiliatesSignupFilterState(state),
		can: selectors.getCan(state),
		calendar: selectors.getCalendar(state),
		calendarSignUpAffiliate: selectors.getCalendarSignUpAffiliate(state),
		table: selectors.getTable(state),
		cellConfig: selectors.getCellConfig(state),
		filters: selectors.getFilters(state),
		currentCurrency: selectors.getCurrentCurrency(state),
		currentDateRange: selectors.getCurrentDateRange(state),
		listOfCurrencies: selectors.getListOfCurrencies(state),
		conversionQuantityInitialValues: selectors.getConversionQuantityInitialValues(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		progressBar: selectors.getProgressBar(state),
		datePeriodFilters: selectors.getDatePeriodFilters(state),
		groupSelect: selectors.getGroupSelect(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates-activity/main.js